import {
  Avatar,
  Backdrop,
  Box,
  Grid,
  Slide,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import './styles.css';
import { GiBroadsword, GiRaiseZombie } from 'react-icons/gi';

type PropTypes = {
  finalScore: number;
  newBestScore: boolean;
  newSlayStreak: boolean;
  questionsSurvived: number;
  playerMeAvatarUrl: string;
  username: string;
};

export const SurvivalStreakMessage = ({
  finalScore,
  newBestScore,
  newSlayStreak,
  questionsSurvived,
  playerMeAvatarUrl,
  username,
}: PropTypes) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(true);
    setTimeout(() => {
      setShow(false);
    }, 5000);
  }, []);

  const theme = useTheme();

  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={show}
    >
      <Box
        sx={{
          width: '800px',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
        }}
      >
        <Slide direction="right" in={show} timeout={700}>
          <Grid
            container
            sx={{
              padding: '0 50px',
              borderColor: '#C4E4D4',
              boxShadow: `0 0 5px 1px #C4E4D4, 0 0 2px 3px #C4E4D4 inset`,
            }}
          >
            <Grid item xs={2}>
              <Box
                sx={{ display: 'flex', height: '100%', alignItems: 'center' }}
              >
                <GiBroadsword
                  style={{
                    fontSize: '80px',
                    color: '#C4E4D4',
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={8}>
              <Stack spacing={1} paddingY={1}>
                {newBestScore || newSlayStreak ? (
                  <Typography variant="h4" letterSpacing={2}>
                    NEW RECORD {username}!
                  </Typography>
                ) : null}
                {newBestScore ? (
                  <Typography variant="h5">
                    New best score:{' '}
                    <Typography
                      variant="h4"
                      fontWeight={600}
                      display={'inline'}
                    >
                      {finalScore}
                    </Typography>
                  </Typography>
                ) : null}
                {newSlayStreak ? (
                  <Typography variant="h5">
                    New slay streak:{' '}
                    <Typography
                      variant="h4"
                      fontWeight={600}
                      display={'inline'}
                    >
                      {questionsSurvived}
                    </Typography>
                  </Typography>
                ) : null}
              </Stack>
            </Grid>
            <Grid item xs={2}>
              <Box
                sx={{ display: 'flex', height: '100%', alignItems: 'center' }}
              >
                <GiRaiseZombie
                  style={{
                    fontSize: '80px',
                    color: theme.palette.survival.main,
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Slide>
      </Box>
    </Backdrop>
  );
};
